import { Component, HostListener, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'app/services/utils.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { BlogListResource } from 'app/models/BlogListResource';

@Component({
  selector: 'vbn-news-intranet',
  templateUrl: './news-intranet.component.html',
  styleUrls: ['./news-intranet.component.scss']
})
export class NewsIntranetComponent implements OnInit {

  errorMessage: any;
  news: BlogListResource;
  dateNow: Date;
  pageNumber: number;
  configPagination: any;
  userEmail: string;
  isOnResponsive: boolean = false;


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerWidth = window.innerWidth;
    if (innerWidth <= 1100) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
  }
  constructor(private service: UtilsService, private router: Router, private _notificationService: NotificationsService,
    private translate: TranslateService,) {
    this.news = new BlogListResource();
    this.dateNow = new Date();
    this.pageNumber = 1;
  }

  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getNewsList();
    const innerWidth = window.innerWidth;
    if (innerWidth <= 1100) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
  }

  getNewsList() {
    this.service.get('/admin/newsCategory/getAllBlogsForAdmin?pageNumber=' + this.pageNumber + "&userEmail=" + this.userEmail)
      .subscribe(
        response => {
          this.news = response;
          this.configPagination = {
            cap: response.numberOfPages,
            start: this.pageNumber
          }
        },
        error => this.errorMessage = <any>error);
  }

  edit(rid) {
    window.scrollTo(500, 0);
    this.router.navigate(['/edit-news-intranet/' + btoa('{ "newsRid" : "' + rid + '"}')]);
  }

  delete(rid) {
    this.service.get(`/admin/newsCategory/deleteBlog/${rid}?userEmail=${this.userEmail}`)
      .subscribe(
        response => {
          forkJoin(
            this.translate.get('Success'),
            this.translate.get('News was deleted!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
          this.getNewsList();
        },
        error => this.errorMessage = <any>error);
  }

  handlePageChange(event) {
    this.pageNumber = event
    this.getNewsList();
  }

  showResponsiveDetails(kioskId) {
    const width = window.innerWidth;
    if (width <= 1100) {
      for (let i = 0; i < this.news.blogList.length; i++) {
        if (this.news.blogList[i].rid == kioskId) {
          this.news.blogList[i].showDetailsOnResponsive = !this.news.blogList[i].showDetailsOnResponsive;
        }
        else {
          this.news.blogList[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }

}
